import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';

import DeleteAdminForm from 'src/components/settings/deleteAdminFrom';

const DeleteAdmin = () => (
  <>
    <Helmet>
      <title>Delete Admin | GMS</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth="lg">
        <DeleteAdminForm />
        <Box sx={{ pt: 3 }}></Box>
      </Container>
    </Box>
  </>
);

export default DeleteAdmin;
